export interface IAd2cpState {
    crit_const_pct_barocline: number
    crit_const_pct_barotrope: number
    crit_maxdepth_shear: number
    crit_mindepth_shear: number
    crit_nb_data_med: number
    crit_nb_data_shear: number
    crit_pitch: number
    crit_rangedepth_shear: number
    crit_roll: number
    crit_shear_east_btm: number
    crit_shear_east_top: number
    crit_shear_north_btm: number
    crit_shear_north_top: number
    crit_speed_x: number
    crit_speed_y: number
    crit_speed_z: number
    current_state: string
    depth_noise: number
    last_process: string
    opti_pitch: number
    opti_roll: number

    crit_const_pct_barocline_p: number
    crit_const_pct_barotrope_p: number
    crit_maxdepth_shear_p: number
    crit_mindepth_shear_p: number
    crit_nb_data_med_p: number
    crit_nb_data_shear_p: number
    crit_pitch_p: number
    crit_rangedepth_shear_p: number
    crit_roll_p: number
    crit_shear_east_btm_p: number
    crit_shear_east_top_p: number
    crit_shear_north_btm_p: number
    crit_shear_north_top_p: number
    crit_speed_x_p: number
    crit_speed_y_p: number
    crit_speed_z_p: number    
    depth_noise_p: number    
    opti_pitch_p: number
    opti_roll_p: number    
}


export const getDefaultAd2cpState = ():IAd2cpState => {
    return {
        crit_const_pct_barocline: 0,
        crit_const_pct_barotrope: 0,
        crit_maxdepth_shear: 0,
        crit_mindepth_shear: 0,
        crit_nb_data_med: 0,
        crit_nb_data_shear: 0,
        crit_pitch: 0,
        crit_rangedepth_shear: 0,
        crit_roll: 0,
        crit_shear_east_btm: 0,
        crit_shear_east_top: 0,
        crit_shear_north_btm: 0,
        crit_shear_north_top: 0,
        crit_speed_x: 0,
        crit_speed_y: 0,
        crit_speed_z: 0,
        current_state: '',
        depth_noise: 0,
        last_process: '',
        opti_pitch: 0,
        opti_roll: 0,
        crit_const_pct_barocline_p: 0,
        crit_const_pct_barotrope_p: 0,
        crit_maxdepth_shear_p: 0,
        crit_mindepth_shear_p: 0,
        crit_nb_data_med_p: 0,
        crit_nb_data_shear_p: 0,
        crit_pitch_p: 0,
        crit_rangedepth_shear_p: 0,
        crit_roll_p: 0,
        crit_shear_east_btm_p: 0,
        crit_shear_east_top_p: 0,
        crit_shear_north_btm_p: 0,
        crit_shear_north_top_p: 0,
        crit_speed_x_p: 0,
        crit_speed_y_p: 0,
        crit_speed_z_p: 0,    
        depth_noise_p: 0,    
        opti_pitch_p: 0,
        opti_roll_p: 0
    }
}